// 路由组件
let routeList = {
  // 培训认证
  // 认证考试
  examinationAttestation: { comment: () => import('@/pages/examination/attestation'), hideMenu: false },
  // 课程考试
  examinationCourse: { comment: () => import('@/pages/examination/course'), hideMenu: false },
  // 考生成绩
  examinationAchievement: { comment: () => import('@/pages/examination/achievement'), hideMenu: false },
  // 试卷库
  examinationQuestionBank: { comment: () => import('@/pages/examination/questionBank'), hideMenu: false },
  // 成绩查询 (认证列表点击成绩查询)
  examinationScoreQuery: { comment: () => import('@/pages/examination/scoreQuery'), hideMenu: true, showMenu: 'examinationAttestation'},
  // 创建考试 (考试认证列表点击创建考试)
  examinationFound: { comment: () => import('@/pages/examination/found'), hideMenu: true, showMenu: 'examinationAttestation'},
  // 试卷库 （添加试题）
  examinationAddQuestions: { comment: () => import('@/pages/examination/addQuestions'), hideMenu: true, showMenu: 'examinationQuestionBank' },
  // 创建考试（考试课程列表点击创建考试）
  examinationCreateCourse: { comment: () => import('@/pages/examination/createCourse'), hideMenu: true, showMenu: 'examinationCourse'},
  // 成绩查询（课程列表点击成绩查询）
  examinationChildAchievement: { comment: () => import('@/pages/examination/childAchievement'), hideMenu: true, showMenu: 'examinationCourse'},
  
  // 课程素材
  examinationMatterList: { comment: () => import('@/pages/examination/matterList'), hideMenu: false },
  //课程管理
  examinationCourseList: { comment: () => import('@/pages/examination/courseList'), hideMenu: false },
  // 课程管理 -> 列表详情
  examinationCourseDetail: { comment: () => import('@/pages/examination/courseDetail'), hideMenu: true, showMenu: 'examinationCourseList'},
  // 课程订单
  examinationCourseOrder: { comment: () => import('@/pages/examination/courseOrder'), hideMenu: false},
  // 试题报错
  examinationTestError: { comment: () => import('@/pages/examination/testError'), hideMenu: false},
  // 数字化工程师
  examinationAutoExamEngineer: { comment: () => import('@/pages/examination/autoExamEngineer'), hideMenu: false},

// h5培训报名
  examinationCertSign: { comment: () => import('@/pages/examination/certSign'), hideMenu: true, showMenu: 'examinationAutoExamEngineer'},


 
  
  // 优惠券列表
  couponsCouponsList: { comment: () => import('@/pages/coupons/couponsList'), hideMenu: false },
  // 添加优惠券
  couponsAddCoupons: { comment: () => import('@/pages/coupons/addCoupons'), hideMenu: true, showMenu: 'couponsCouponsList'},
  // 优惠券使用记录
  couponsCouponsUse: { comment: () => import('@/pages/coupons/couponsUse'), hideMenu: false},
  // 优惠券过期记录
  couponsCouponsOverdue: { comment: () => import('@/pages/coupons/couponsOverdue'), hideMenu: false},
  // 优惠券发放记录
  couponsCouponsIssue: { comment: () => import('@/pages/coupons/couponsIssue'), hideMenu: false},
  





  // 客户管理
  // 公海客户
  customerSeasCustomer: { comment: () => import('@/pages/customer/seasCustomer'), hideMenu: false },
  // 公海客户-客户信息
  customerCustomerInfo: { comment: () => import('@/pages/customer/customerInfo'), hideMenu: true, showMenu: 'customerSeasCustomer'},
  // 我的客户
  customerMyCustomer: { comment: () => import('@/pages/customer/myCustomer'), hideMenu: false },
  // 我的客户-客户信息
  customerMyCustomerInfo: { comment: () => import('@/pages/customer/myCustomerInfo'), hideMenu: true, showMenu: 'customerMyCustomer'},
  // 商机列表
  customerDealerList: { comment: () => import('@/pages/customer/dealerList'), hideMenu: false },
  // 商机信息
  customerDealerInfo: { comment: () => import('@/pages/customer/dealerInfo'), hideMenu: true, showMenu: 'customerDealerList' },
  // 商机信息-客户信息
  customerDealerCustomerInfo: { comment: () => import('@/pages/customer/dealerCustomerInfo'), hideMenu: true, showMenu: 'customerDealerList' },
  // 销售数据
  customerSalesData: { comment: () => import('@/pages/customer/salesData'), hideMenu: false },
  // END






  // 系统管理
  // 角色配置
  systemRoleConfig: { comment: () => import('@/pages/system/roleConfig'), hideMenu: false },
  // 菜单管理
  systemMenuManag: { comment: () => import('@/pages/system/menuManag'), hideMenu: false },
  // 功能管理
  systemFunctionManag: { comment: () => import('@/pages/system/functionManag'), hideMenu: false },
  // 菜单配置-设置菜单
  systemSetMenu: { comment: () => import('@/pages/system/setMenu'), hideMenu: true, showMenu: 'systemRoleConfig'},
  // 菜单配置-设置功能
  systemSetFunction: { comment: () => import('@/pages/system/setFunction'), hideMenu: true, showMenu: 'systemRoleConfig' },
  // END





  // 数据设置
  // 行业数据库管理
  dataFrameIndustry: { comment: () => import('@/pages/dataFrame/industry'), hideMenu: false },
  // 弹框消息管理
  dataFrameMessageBoxList: { comment: () => import('@/pages/dataFrame/messageBoxList'), hideMenu: false},
  // 行业数据库管理
  dataFrameCertificate: { comment: () => import('@/pages/dataFrame/certificate'), hideMenu: false},

 


  
  // 工单管理
  // B2B工单列表
  jobB2bJobList: { comment: () => import('@/pages/job/b2bJobList'), hideMenu: false },
  // B2B工单详情
  jobB2bJobInfo: { comment: () => import('@/pages/job/b2bJobInfo'), hideMenu: true, showMenu: 'jobB2bJobList' },
  // 自由工单列表
  jobFreeJobList: { comment: () => import('@/pages/job/freeJobList'), hideMenu: false },
  // 自由工单详情
  jobFreeJobInfo: { comment: () => import('@/pages/job/freeJobInfo'), hideMenu: true, showMenu: 'jobFreeJobList' },
 
  // 财务管理 -> 收款管理
  // 项目服务利润
  proceedsProjectServeList: { comment: () => import('@/pages/proceeds/projectServeList'), hideMenu: false },
  // 平台服务利润
  proceedsPlatformServeList: { comment: () => import('@/pages/proceeds/platformServeList'), hideMenu: false },
  // 项目款项
  proceedsProjectPaymentList: { comment: () => import('@/pages/proceeds/projectPaymentList'), hideMenu: false },
  // 应收账款
  proceedsReceivablesList: { comment: () => import('@/pages/proceeds/receivablesList'), hideMenu: false },
  // 已收款项
  proceedsReceivedPaymentList: { comment: () => import('@/pages/proceeds/receivedPaymentList'), hideMenu: false },
  // 发票管理
  proceedsInvoiceList: { comment: () => import('@/pages/proceeds/invoiceList'), hideMenu: false },
  //测试大文件上传使用
  // proceedsMaxUpload: { comment: () => import('@/pages/proceeds/maxUpload'), hideMenu: false },

 // 线下发票  (注意，key(proceedsOfflineInvoice)的格式：根据页面的路径/pages/proceeds/offlineInvoices转化而来，且第二个路径首字母要大写)
   proceedsOfflineInvoice: { comment: () => import('@/pages/proceeds/offlineInvoice'), hideMenu: false },
  
  // 财务管理 -> 支出管理
  // 项目应付款
  expenditureProjectPayableList: { comment: () => import('@/pages/expenditure/projectPayableList'), hideMenu: false },
  // 项目付款管理
  expenditureProjectPayList: { comment: () => import('@/pages/expenditure/projectPayList'), hideMenu: false },





  
  // 市场管理
  // 新闻管理
  marketNewsList: { comment: () => import('@/pages/market/newsList'), hideMenu: false },
  // 大咖面对面
  marketVideoList: { comment: () => import('@/pages/market/videoList'), hideMenu: false },
  // 大咖面对面详情
  marketVideoDetail: { comment: () => import('@/pages/market/videoDetail'), hideMenu: true, showMenu: 'marketVideoList' },
  



  // 消息模块
  chatChatContent: { comment: () => import('@/pages/chat/chatContent'), hideMenu: false},
  chatChatContentGroup: { comment: () => import('@/pages/chat/chatContentGroup'), hideMenu: false},
  //
  chatMessageList: { comment: () => import('@/pages/chat/messageList'), hideMenu: false},

 

  // 佣金提现
  expenditureWithdrawDeposit: { comment: () => import('@/pages/expenditure/withdrawDeposit'), hideMenu: false },


  // 国家认证
  examinationCountriesList: { comment: () => import('@/pages/examination/countriesList'), hideMenu: false},
  // 创建/编辑 国家认证
  examinationCountriesDetail: { comment: () => import('@/pages/examination/countriesDetail'), hideMenu: true, showMenu: 'examinationCountriesList'},
  // 国家认证面试
  examinationCountriesInterview: { comment: () => import('@/pages/examination/countriesInterview'), hideMenu: false},
  // 原厂认证
  examinationOriginalList: { comment: () => import('@/pages/examination/originalList'), hideMenu: false},
  // 创建/编辑 原厂认证
  examinationOriginalDetail: { comment: () => import('@/pages/examination/originalDetail'), hideMenu: true, showMenu: 'examinationOriginalList'},
  // 原厂认证考核
  examinationOriginalInterview: { comment: () => import('@/pages/examination/originalInterview'), hideMenu: false},
  // 大咖审核
  examinationExpertList: { comment: () => import('@/pages/examination/expertList'), hideMenu: false},





  // 运营管理
  // 已发帖子
  runSentPost:{ comment: () => import('@/pages/run/sentPost'), hideMenu: false},
  // 已发帖子详情
  runSentPostDetail:{ comment: () => import('@/pages/run/sentPostDetail'), hideMenu: true, showMenu: 'runSentPost'},
  // 举报处理
  runReportPost:{ comment: () => import('@/pages/run/reportPost'), hideMenu: false},
  // 举报处理帖子详情
  runReportPostDetail:{ comment: () => import('@/pages/run/reportPostDetail'), hideMenu: true, showMenu: 'runReportPost'},
  // 奖品设置
  runPrizeSetting:{ comment: () => import('@/pages/run/prizeSetting'), hideMenu: false},
  // 奖品发放
  runPrizeGrant:{ comment: () => import('@/pages/run/prizeGrant'), hideMenu: false},
  // 红包抽奖设置
  runRedEnvelopesSetting:{ comment: () => import('@/pages/run/redEnvelopesSetting'), hideMenu: false},
  // 意见反馈
  runFeedBack:{ comment: () => import('@/pages/run/feedBack'), hideMenu: false},
  


  // 工业服务论坛
  runServiceBBS:{ comment: () => import('@/pages/run/serviceBBS'), hideMenu: false},
   // 工程师大赛
   runEngineerExam:{ comment: () => import('@/pages/run/engineerExam'), hideMenu: false},

  // 平台协议
  contractAgreement:{ comment: () => import('@/pages/contract/agreement'), hideMenu: false},





  // v4.2.3 接口 -->刘博
  // 人员维护
  runPeople:{ comment: () => import('@/pages/run/people'), hideMenu: false},
  // 人员维护-企业指标
  runCompanyTarget: { comment: () => import('@/pages/run/companyTarget'), hideMenu: true, showMenu: 'runPeople' },
 
  // 意见反馈
  runFeedBack:{ comment: () => import('@/pages/run/feedBack'), hideMenu: false},
  
  // 会话记录
  runWeChatLog:{ comment: () => import('@/pages/run/weChatLog'), hideMenu: false},
  
  // 会话记录
  runWeChatLog:{ comment: () => import('@/pages/run/weChatLog'), hideMenu: false},

  //设置节假日
  runSetHoliday:{ comment: () => import('@/pages/run/setHoliday'), hideMenu: false},

  //企微群聊监控配置
  runComWxGroupMonitorConfig:{ comment: () => import('@/pages/run/comWxGroupMonitorConfig'), hideMenu: false},

  // D--添加的路由 
  // v4.4 接口 -->周支业
  //产品库
  dataFrameProductLibrary:{comment: ()=> import('@/pages/dataFrame/productLibrary'), hideMenu: false},
  //品牌库
  dataFrameBrandLibrary: { comment: () => import('@/pages/dataFrame/brandLibrary'), hideMenu: false},
  //系列库
  dataFrameSeriesLibrary: { comment: () => import('@/pages/dataFrame/seriesLibrary'), hideMenu: false},
  //服务类型库
  dataFrameServiceTypelibrary: { comment: () => import('@/pages/dataFrame/serviceTypelibrary'), hideMenu: false},
  //服务库
  dataFrameServiceLibrary: { comment: () => import('@/pages/dataFrame/serviceLibrary'), hideMenu: false},
  // 新增offer
  dataFrameNewServices: { comment: () => import('@/pages/dataFrame/newServices'), hideMenu: true, showMenu: 'dataFrameServiceLibrary'},
  //服务详情
  dataFrameServiceDetails: { comment: () => import('@/pages/dataFrame/serviceDetails'), hideMenu: true, showMenu: 'dataFrameServiceLibrary'},
  //发单信息
  dataFrameBillingInformation: { comment: () => import('@/pages/dataFrame/billingInformation'), hideMenu: false},


  // 企业用户
  customerEnterpriseCustomer: { comment: () => import('@/pages/customer/enterpriseCustomer'), hideMenu: false },
  // 企业用户详情
  customerEnterpriseCustomerInfo: { comment: () => import('@/pages/customer/enterpriseCustomerInfo'), hideMenu: true, showMenu: 'customerEnterpriseCustomer' },
  // D--添加的路由 end

 // 销售管理-动态预警 (注意，key(salerManageSalesStatistics)的格式：根据页面的路径/salerManage/salesStatistics转化而来，且第二个路径首字母要大写)
 salerManageSalesStatistics: { comment: () => import('@/pages/salerManage/salesStatistics'), hideMenu: false },
 //每日统计
 salerManageJobStatistics: { comment: () => import('@/pages/salerManage/jobStatistics'), hideMenu: false },
 
  //edi工单
  salerManageEdiJobList: { comment: () => import('@/pages/salerManage/ediJobList'), hideMenu: false },
  // 众业达子公司客户工单,showMenu为要选中哪个菜单
  salerManageZydJobList: { comment: () => import('@/pages/salerManage/zydJobList'), hideMenu: true, showMenu: 'salerManageEdiJobList'  },


  //报表中心-客户待开票工单
  reportCenterWaitInvoiceJob: { comment: () => import('@/pages/reportCenter/waitInvoiceJob'), hideMenu: false },
//报表中心-利润率数据统计
  reportCenterReceiverJobStatistice: { comment: () => import('@/pages/reportCenter/receiverJobStatistice'), hideMenu: false },
  //报表中心-利润率统计
  reportCenterAmountRateStatistice: { comment: () => import('@/pages/reportCenter/amountRateStatistice'), hideMenu: false },
  //报表中心-好评率统计
  reportCenterGoodEvaluateStatistice: { comment: () => import('@/pages/reportCenter/goodEvaluateStatistice'), hideMenu: false },
    //报表中心-好评率统计
  reportCenterGoodEvaluateStatistice: { comment: () => import('@/pages/reportCenter/goodEvaluateStatistice'), hideMenu: false },

  //自动派单
  distributeJobDistributeJobConfig: { comment: () => import('@/pages/distributeJob/distributeJobConfig'), hideMenu: false },
  //值班配置
  distributeJobDutyConfig: { comment: () => import('@/pages/distributeJob/dutyConfig'), hideMenu: true , showMenu: 'distributeJobDistributeJobConfig' },
}

export const vueComment = routeList

